import { Spin } from "antd"

const LoadMore = ({ loader = false, onClick }) => {
    return (
        <div onClick={onClick} className="flex justify-center cursor-pointer items-center gap-4 border rounded-md w-48 p-2">
            {loader && <Spin />}
            <div className="text-base font-medium">
                Show More
            </div>
        </div>
    )
}
export default LoadMore